import { publicConfig } from './config'
import { trackConversion } from './analytics'
import { ApplyLink, Arrow, SectionLabel } from './ui'
import './registration-link.css'

export default function RegistrationLinkSection() {
  return <section className="registration-section application-gateway section-pad" id="apply" aria-labelledby="apply-title">
    <div className="application-gateway-intro">
      <SectionLabel number="11">YOUR NEXT CHAPTER</SectionLabel>
      <h2 id="apply-title">เริ่มต้นเรื่องราว<br /><em>บทใหม่ของคุณ</em></h2>
      <p>สมัคร EMPRESS OF WELLNESS 2026<br />เวทีสำหรับผู้หญิงวัย 35+ ที่พร้อมเติบโตไปด้วยกัน</p>
    </div>
    <div className="application-gateway-card">
      <span className="application-gateway-tag">แบบฟอร์มสมัครอย่างเป็นทางการ</span>
      <svg className="application-gateway-icon" aria-hidden="true" viewBox="0 0 48 48" fill="none"><rect x="11" y="7" width="26" height="35" rx="4" stroke="currentColor" strokeWidth="1.5" /><rect x="18" y="4" width="12" height="7" rx="2" fill="currentColor" /><path d="M18 20h12M18 27h12M18 34h7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
      <p className="application-gateway-eyebrow">EMPRESS OF WELLNESS 2026</p>
      <h3>กรอกใบสมัคร<br />ผ่าน Google Form</h3>
      <p className="application-gateway-copy">กดปุ่มด้านล่างเพื่อกรอกข้อมูลและแนบเอกสาร<br />ในแบบฟอร์มสมัครของโครงการ</p>
      <ApplyLink location="application-google-form" light />
      <p className="application-gateway-hint">เปิดแบบฟอร์มในแท็บใหม่ · เตรียมบัญชี Google สำหรับแนบไฟล์</p>
      <a className="application-gateway-url" href={publicConfig.registrationUrl} target="_blank" rel="noopener noreferrer" aria-label="เปิดลิงก์ Google Form สมัคร EMPRESS OF WELLNESS (แท็บใหม่)" onClick={() => trackConversion('cta_click', 'application-form-url')}>{publicConfig.registrationUrl.replace('https://', '')}<Arrow /></a>
    </div>
    <div className="application-gateway-preparation">
      <div className="application-gateway-fee"><span>ค่าสมัครเข้าร่วม</span><strong>2,500 <small>บาท</small></strong></div>
      <h3>เตรียมไว้ก่อนเริ่มกรอก</h3>
      <ul><li>รูปถ่ายเต็มตัว 1 รูป</li><li>รูปครึ่งตัวหรือหน้าตรง 1 รูป</li><li>คลิปแนะนำตัวไม่เกิน 1 นาที</li><li>สลิปโอนค่าสมัคร 2,500 บาท</li></ul>
      <p>กรอกข้อมูลให้ครบ แล้วกดส่งใน Google Form<br />รายละเอียดและเงื่อนไขการสมัครอยู่ในแบบฟอร์ม</p>
      <a className="text-link" href={publicConfig.lineOfficialUrl} target="_blank" rel="noopener noreferrer" onClick={() => trackConversion('line_click', 'application')}>สอบถามทีมงานผ่าน LINE Official <Arrow /></a>
    </div>
  </section>
}
